import DataTable from '../components/Common/DataTable.vue'
import DateColumn from '../components/Common/DateColumn.vue'
import DateTimeColumn from '../components/Common/DateTimeColumn.vue'
import CurrencyColumn from '../components/Common/CurrencyColumn.vue'
import DateTimePickr from '../components/Common/DateTimePickr.vue'

const CommonComponents = function install(Vue) {
	Vue.mixin({
		methods: {
			showError(error) {
				let message = '';
				if (error?.response?.data?.errors) {
					const errors = error.response.data.errors;

					if (errors.length && errors[0].errorMessage) {
						message = error.response.data.errors[0].errorMessage;
					}
				}

				if (!message && error) {
					if (typeof error == 'string')
						message = error;
					else
						message = error.errorMessage;
				}

				if (!message) {
					console.log(`Error: `, error)
					message = 'Something bad has happened, Please contact administrator';
				}

				this.$message.error(message);
			},
			showSuccess(response) {
				let message = response?.data?.result?.message ? response?.data?.result?.message : 'Action done successfully';
				this.$message.success(message);
			}
		},
		components: {
			DataTable,
			DateColumn,
			DateTimeColumn,
			CurrencyColumn,
			DateTimePickr
		}
	});
}

export default CommonComponents;
